import { Button } from "@progress/kendo-react-buttons";
import { DateInput } from "@progress/kendo-react-dateinputs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { TextBoxProps } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { InputPicker } from "rsuite";
import { useParams } from "react-router";
import countryCodes from "country-codes-list";
import { Error } from "@progress/kendo-react-labels";
import {
  FormCheckbox,
  FormDatePicker,
  FormDropDownList,
  FormMaskedTextBox,
  FormMaskedTextBoxMobile,
  FormNumericTextBox,
} from "./formControls";
import { FormFileUpload } from "./FormFileUpload";

export interface OrganizationProps {
  getOrganizationFormData: (legalName: string) => void;
  customerData?: any;
  formType?: String;
  adminUserState?: Function;
  uploadFileToS3?: Function;
  removeFileFromS3?: Function;
  pageType?: "admin" | "tenant" | string;
  onGenerateInvoice?: (payload: {
    type: string;
    year: number;
    month: number;
    fromTime: number;
    tillTime: number;
  }) => void;
}

// Pricing configuration interface
export interface PricingConfig {
  pricePerTotalUser: number;
  pricePerActiveUser: number;
  pricePerCardToActive: number;
  discountPercent: number;
}

export function OrganizationForm(props: OrganizationProps) {
  console.log("I am inside organization");
  const intl = useIntl();

  const certificationValues: { [key: string]: string } = {
    true: intl.formatMessage({ id: "personal.enabled" }),
    false: intl.formatMessage({ id: "personal.disabled" }),
  };

  console.log(
    "print organization details in organiztion form shared-ui",
    props.customerData
  );

  console.log(
    "props.customerData.featureAccess.certification",
    props?.customerData?.featureAccess?.certification
  );

  const [certificationValue, setCertificationValue] = useState(
    intl.formatMessage({ id: "personal.disabled" })
  );
  const [fileData, setFileData] = useState<any>();
  const [previousLogoName, setPreviousLogoName] = useState<any>();
  const [signature1, setSignature1] = useState<any>();
  const [signature2, setSignature2] = useState<any>();
  const [previousSignature1, setPreviousSignature1] = useState<any>();
  const [previousSignature2, setPreviousSignature2] = useState<any>();
  const [isCertificationCollapsed, setIsCertificationCollapsed] =
    useState(true);
  const [isInvoiceCollapsed, setIsInvoiceCollapsed] = useState(true);
  const [isPricingCollapsed, setIsPricingCollapsed] = useState(true);

  // Pricing state
  const [pricingConfig, setPricingConfig] = useState<{
    pricePerTotalUser: number;
    pricePerActiveUser: number;
    pricePerCardToActive: number;
    discountPercent: number;
  }>({
    pricePerTotalUser: props?.customerData?.pricingConfig?.pricePerTotalUser || 5,
    pricePerActiveUser: props?.customerData?.pricingConfig?.pricePerActiveUser || 3,
    pricePerCardToActive: props?.customerData?.pricingConfig?.pricePerCardToActive || 1,
    discountPercent: props?.customerData?.pricingConfig?.discountPercent || 0,
  });

  // Helper to check if user is admin
  const isAdmin = props.pageType === "admin";

  console.log("file data print", fileData);
  console.log("certification value print", certificationValue);
  console.log("print previous logo name outside", previousLogoName);
  console.log("print customer data logo outside", props?.customerData?.logo);
  console.log(
    "print this content",
    previousLogoName || props?.customerData?.logo
  );
  console.log(
    "singature 1 outside",
    props?.customerData?.featureAccess?.certification_details?.sign1?.signUrl
  );

  useEffect(() => {
    const certificationValue =
      certificationValues[props?.customerData?.featureAccess?.certification] ||
      intl.formatMessage({ id: "personal.disabled" });
    setCertificationValue(certificationValue); // Update state when props change
  }, [props?.customerData?.featureAccess?.certification]); // Watch for changes in certification

  console.log("customer data status", props?.customerData?.status);
  console.log("customer data accnt id", props?.customerData?.accntId);
  console.log("ai model out", props?.customerData?.aiModel);
  const params = useParams();
  const orgRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]+$/);
  const legalNameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]+$/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const mobileEditRegex: RegExp = new RegExp(/^\+[0-9]{5,20}$/);
  const mobileRegexUpdate: RegExp = /^(\+[0-9]{5,20})$/;
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const addressRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]+$/);
  const cityRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]+$/);
  const stateRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]+$/);
  const zipCodeRegex: RegExp = new RegExp(/^[0-9]{6}$/);
  const taxRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.&*#,-]{6}$/);

  // Fix: Use string keys directly instead of CountryProperty enum
  const allCountryList = countryCodes?.customList("countryNameEn");
  const allCountries = Object.entries(allCountryList).map(
    ([key, value]) => value
  );

  const [clientLogo, setClientLogo] = useState<string>();

  console.log("client logo print", clientLogo);
  console.log(
    "customer data logo print in organization form",
    props?.customerData?.logo
  );

  const countryNameList = allCountries.map((countryString) => {
    const countryName = countryString.replace(/\s*\([^)]*\)/, "").trim();
    return countryName;
  });

  const CustomMobileLabel = () => (
    <div>
      <span>
        <FormattedMessage id="user.createUser.mobile"></FormattedMessage>
      </span>
      <span className="text-[10px] italic">
        {/* (including country code) */}
        <FormattedMessage id="user.createUser.countryCode"></FormattedMessage>
      </span>
    </div>
  );

  const navigate = useNavigate();

  const complexSimpleModelMapping: { [key: string]: string } = {
    "gpt-3.5-turbo-0125": "gpt3p5",
    "gpt-4-turbo": "gpt4",
    "gpt-4o": "gpt4o",
  };

  const analyticsValues: { [key: string]: string } = {
    true: intl.formatMessage({ id: "personal.enabled" }),
    false: intl.formatMessage({ id: "personal.disabled" }),
  };

  const invoiceTypeOptions = [
    {
      text: intl.formatMessage({ id: "organization.invoiceType.totalUsers" }),
      value: "TOTAL_USERS",
    },
    {
      text: intl.formatMessage({ id: "organization.invoiceType.activeUsers" }),
      value: "ACTIVE_USERS",
    },
    {
      text: intl.formatMessage({ id: "organization.invoiceType.cardsToActive" }),
      value: "CARDS_TO_ACTIVE",
    },
  ];

  // Invoice helpers
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonthIndex = now.getMonth(); // zero-based
  const defaultInvoiceYear =
    currentMonthIndex === 0 ? currentYear - 1 : currentYear;
  const [invoiceSelection, setInvoiceSelection] = useState<{
    type: string;
    year: number;
    monthName: string;
  }>({
    type: "",
    year: defaultInvoiceYear,
    monthName: "",
  });

  const getMonthName = (monthNumber?: number | string) => {
    if (!monthNumber) {
      return "";
    }
    const num = typeof monthNumber === "string" ? parseInt(monthNumber) : monthNumber;
    if (isNaN(num) || num < 1 || num > 12) {
      return "";
    }
    return monthNames[num - 1];
  };

  const getAllowedMonths = (year?: number | string): string[] => {
    if (year === undefined || year === null || year === "") {
      return [];
    }
    // Convert to number for safe comparison
    const numYear = typeof year === "string" ? parseInt(year, 10) : year;
    if (isNaN(numYear)) {
      return [];
    }
    // For past years, allow all 12 months
    if (numYear < currentYear) {
      return monthNames; // All months for past years
    }
    // For current year, only allow months before current month
    if (numYear === currentYear) {
      return monthNames.slice(0, currentMonthIndex);
    }
    // Future years not allowed
    return [];
  };

  const invoiceMonthOptions = (year?: number | string) =>
    getAllowedMonths(year).map((name) => ({
      text: name,
      value: name,
    }));

  // If current month is January (index 0), don't show current year (no invoices for Jan yet)
  const yearOptions = currentMonthIndex === 0 
    ? [currentYear - 1, currentYear - 2]
    : [currentYear, currentYear - 1, currentYear - 2];
  const invoiceYearOptions = yearOptions.map((yr) => ({
    text: `${yr}`,
    value: yr,
  }));

  const getMonthIndex = (monthName: string) => monthNames.indexOf(monthName);
  const [selectedInvoiceYear, setSelectedInvoiceYear] =
    useState<number | undefined>(undefined);

  // const auditValues: { [key: string]: string } = {
  //   true: "Enabled",
  //   false: "Disabled",
  // };

  const [showNewOragnization, setShowNewOragnization] = useState<any>({});
  const [showSavebutton, setSavebutton] = useState(true);
  const [showtoggle, settoggle] = useState(false);

  const [errors, setErrors] = useState<any>({});
  const [invoiceError, setInvoiceError] = useState<string>("");
  const [finalCountryCode, setFinalCountryCode] = useState<any>();

  console.log(props?.customerData);

  async function signIn(formData: { [name: string]: any }) {
    console.log("inside signin");
    let data: any = {};
    setInvoiceError("");

    data["legalName"] = formData["legalName"];
    data.orgName = formData["orgName"];
    data.distAcc = [checkboxStates];
    data.addrLine1 = formData["addrLine1"];
    data.addrLine2 = formData["addrLine2"];
    data.city = formData["city"];
    data.state = formData["state"];
    data.country = formData["country"];

    if (props.formType === "NEW") {
      const countryCodeIndex = countryCode?.lastIndexOf(":");
      const countryCodeNumber = countryCode
        ?.substring(countryCodeIndex + 1)
        ?.trim();

      setFinalCountryCode(countryCodeNumber);

      data.userProfile = data.userProfile || {};
      data.userProfile.phNo =
        countryCodeNumber && countryCodeNumber + formData["phNo"];

      // console.log("final country code", finalCountryCode);

      console.log("please enter mobile number field data", formData["phNo"]);
      console.log("phone number in organization form", data.userProfile.phNo);
      if (!countryCodeNumber && formData["phNo"]) {
        console.log("inside undefined of country code");
        let err: any = {};
        err.noCountryCode = {
          error: intl.formatMessage({ id: "users.createUser.countryCode" }),
        };
        setErrors(err);
        return false;
      }
    } else if (props.formType === "EDIT") {
      data.userProfile = data.userProfile || {};
      data.userProfile.phNo = formData["phNo"];
    }

    data.email = formData["email"];
    data.zipCode = formData["zipCode"];
    data.whatsapp = checkboxStates.whatsappCheck;
    data.whatAccessToken = formData["whatAccessToken"];
    data.teams = checkboxStates.teamsCheck;
    data.teamAccessToken = formData["teamAccessToken"];
    data.slack = checkboxStates.slackCheck;
    data.slackAccessToken = formData["slackAccessToken"];
    data.emailCheck = checkboxStates.emailCheck;
    data.emailAccessToken = formData["emailAccessToken"];
    data.validUpTo = formData["validUpTo"];
    data.tax = formData["tax"];
    data.status = formData["status"];
    data.aiModel = formData["aiModel"];
    data.analytics = features.analyticsCheck;
    data.logo = fileData || props?.customerData?.logo || "";

    data.featureAccess = data.featureAccess || {};
    data.featureAccess.audit = features.auditCheck;
    data.featureAccess.certification = features.certificationCheck;

    data.featureAccess.certification_details =
      data.featureAccess.certification_details || {};

    data.featureAccess.certification_details.sign1 =
      data.featureAccess.certification_details.sign1 || {};
    data.featureAccess.certification_details.sign2 =
      data.featureAccess.certification_details.sign2 || {};

    data.featureAccess.certification_details.sign1 = {
      ...data.featureAccess.certification_details.sign1,
      signerName: formData["nameOfSigner1"] || "",
      signerRole: formData["roleOfSigner1"] || "",
      signUrl:
        signature1 ||
        props?.customerData?.featureAccess?.certification_details?.sign1
          ?.signUrl ||
        "",
    };

    data.featureAccess.certification_details.sign2 = {
      ...data.featureAccess.certification_details.sign2,
      signerName: formData["nameOfSigner2"] || "",
      signerRole: formData["roleOfSigner2"] || "",

      signUrl:
        signature2 ||
        props?.customerData?.featureAccess?.certification_details?.sign2
          ?.signUrl ||
        "",
    };

    console.log("ai model selected", data.aiModel);
    console.log(data, "data1 organization form customer");

    // Invoice selection - only validate and include if ALL invoice fields are filled
    const invoiceTypeValue =
      typeof formData["invoiceType"] === "string"
        ? formData["invoiceType"]
        : formData["invoiceType"]?.value;
    const parsedInvoiceYear = formData["invoiceYear"];
    const invoiceYearValue =
      parsedInvoiceYear !== undefined && !isNaN(Number(parsedInvoiceYear))
        ? Number(parsedInvoiceYear)
        : undefined;
    const invoiceMonthName = formData["invoiceMonth"] || "";
    const invoiceMonthIndex = monthNames.indexOf(invoiceMonthName);
    
    // Only include invoiceConfig if all required fields are present
    // This makes invoice configuration optional for org update
    const hasAllInvoiceFields = invoiceTypeValue && invoiceYearValue && invoiceMonthName;
    
    if (hasAllInvoiceFields) {
      const effectiveYear = invoiceYearValue || (selectedInvoiceYear !== undefined ? selectedInvoiceYear : currentYear);
      // Validate only if all fields are present
      if (
        invoiceMonthIndex === -1 ||
        effectiveYear > currentYear ||
        (effectiveYear === currentYear && invoiceMonthIndex >= currentMonthIndex)
      ) {
        setInvoiceError(intl.formatMessage({ id: "organization.invoiceMonthFuture" }));
        return;
      }

      data.invoiceConfig = {
        type: invoiceTypeValue,
        year: invoiceYearValue,
        month: invoiceMonthIndex >= 0 ? invoiceMonthIndex + 1 : undefined,
      };
    }

    // Include pricing config (only admin can set/modify these)
    if (isAdmin) {
      data.pricingConfig = {
        pricePerTotalUser: Number(formData["pricePerTotalUser"]) || pricingConfig.pricePerTotalUser || 0,
        pricePerActiveUser: Number(formData["pricePerActiveUser"]) || pricingConfig.pricePerActiveUser || 0,
        pricePerCardToActive: Number(formData["pricePerCardToActive"]) || pricingConfig.pricePerCardToActive || 0,
        discountPercent: Number(formData["discountPercent"]) || pricingConfig.discountPercent || 0,
      };
    }

    props.getOrganizationFormData(data);
    if (props.adminUserState) {
      props.adminUserState(true);
    }
  }
  const [checkboxStates, setCheckboxStates] = useState({
    whatsappCheck: false,
    teamsCheck: false,
    slackCheck: false,
    emailCheck: false,
  });

  const [features, setFeature] = useState({
    analyticsCheck: false,
    auditCheck: false,
    certificationCheck: false,
  });

  const handleCancelClick = () => {
    props.pageType === "tenant" ? navigate("/home") : navigate("/customer");
  };

  const handleCheckboxChange = (checkboxId: any) => {
    setCheckboxStates((prevStates: any) => ({
      ...prevStates,
      [checkboxId]: !prevStates[checkboxId],
    }));
  };

  const handleFeatureAccess = (checkboxId: any) => {
    setFeature((prevStates: any) => ({
      ...prevStates,
      [checkboxId]: !prevStates[checkboxId],
    }));
  };

  const validators = {
    orgRegexValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "organization.orgNameValidation" })}`
        : orgRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "organization.orgNameAnotherValidation",
          })}`,

    legalNameRegexValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "organization.legalNameValidation" })}`
        : legalNameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "organization.legalNameAnotherValidation",
          })}`,
    mobileNumberValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "organization.mobileNumberValidation" })}`
        : mobileRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.mobileNumberValidation",
          })}`,
    mobileNumberUpdateValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "organization.mobileNumberValidation" })}`
        : mobileRegexUpdate.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.mobileNumberValidation",
          })}`,

    mobileNumberEditValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.mobileNumberValidation" })
        : mobileEditRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.mobileNumberAnotherValidation",
          }),
    emailValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.emailValidation" })
        : emailRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.emailAnotherValidation" }),
    addrLine1Validator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.addressValidation" })
        : addressRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.addressAnotherValidation" }),
    addrLine2Validator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.addressValidation" })
        : addressRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.addressAnotherValidation" }),
    cityValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.cityValidation" })
        : cityRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.cityAnotherValidation" }),
    stateValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.stateValidation" })
        : stateRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.stateAnotherValidation" }),
    zipCodeValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.zipCodeValidation" })
        : zipCodeRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.zipCodeAnotherValidation" }),
    // dateValidator: (value: DateInput) => (!value ? "Select date" : ""),
    dateValidator: (value: string) => (!value ? "Select date" : ""),

    taxValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.taxValdation" })
        : taxRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "organization.taxValdation" }),
    statusValidator: (value: string) =>
      !value ? intl.formatMessage({ id: "organization.statusValidation" }) : "",
    countryValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.countryValidation" })
        : "",
    invoiceTypeValidator: (value: any) => {
      const resolvedValue = typeof value === "string" ? value : value?.value;
      return !resolvedValue
        ? intl.formatMessage({ id: "organization.invoiceTypeRequired" })
        : "";
    },
    invoiceYearValidator: (value: number | string) => {
      if (value === undefined || value === null || value === "") {
        return intl.formatMessage({ id: "organization.invoiceYearRequired" });
      }
      const numValue = typeof value === "string" ? parseInt(value, 10) : value;
      if (isNaN(numValue)) {
        return intl.formatMessage({ id: "organization.invoiceYearRequired" });
      }
      if (!yearOptions.includes(numValue)) {
        return intl.formatMessage({ id: "organization.invoiceYearInvalid" });
      }
      return "";
    },
    invoiceMonthValidator: (value: string | { value?: string }) => {
      const monthValue =
        typeof value === "string" ? value : value?.value || "";
      const rawYear =
        selectedInvoiceYear !== undefined ? selectedInvoiceYear : (invoiceSelection.year || defaultInvoiceYear);
      // Convert year to number for safe comparison
      const year = typeof rawYear === "string" ? parseInt(rawYear, 10) : rawYear;
      if (!monthValue) {
        return intl.formatMessage({ id: "organization.invoiceMonthRequired" });
      }
      if (year === undefined || isNaN(year) || !yearOptions.includes(year)) {
        return intl.formatMessage({ id: "organization.invoiceYearInvalid" });
      }
      const monthIndex = monthNames.indexOf(monthValue);
      if (monthIndex === -1) {
        return intl.formatMessage({ id: "organization.invoiceMonthInvalid" });
      }
      // For past years, all months are valid
      if (year < currentYear) {
        return "";
      }
      // For current year, only past months are valid
      if (year === currentYear) {
        if (monthIndex >= currentMonthIndex) {
          return intl.formatMessage({ id: "organization.invoiceMonthFuture" });
        }
        return "";
      }
      // Future years not allowed
      return intl.formatMessage({ id: "organization.invoiceMonthInvalid" });
    },
  };

  const validateInvoiceSelection = (type: string, yearInput: number | string, monthName: string) => {
    // Convert year to number for safe comparison
    const year = typeof yearInput === "string" ? parseInt(yearInput, 10) : yearInput;
    if (!type || !year || isNaN(year) || !monthName) {
      setInvoiceError(intl.formatMessage({ id: "organization.invoiceMissing" }));
      return false;
    }
    if (!yearOptions.includes(year)) {
      setInvoiceError(intl.formatMessage({ id: "organization.invoiceYearInvalid" }));
      return false;
    }
    const monthIndex = getMonthIndex(monthName);
    if (monthIndex === -1) {
      setInvoiceError(intl.formatMessage({ id: "organization.invoiceMonthInvalid" }));
      return false;
    }
    // For past years, all months are valid
    if (year < currentYear) {
      setInvoiceError("");
      return true;
    }
    // For current year, only past months are valid
    if (year === currentYear) {
      if (monthIndex >= currentMonthIndex) {
        setInvoiceError(intl.formatMessage({ id: "organization.invoiceMonthFuture" }));
        return false;
      }
      setInvoiceError("");
      return true;
    }
    // Future years not allowed
    setInvoiceError(intl.formatMessage({ id: "organization.invoiceMonthInvalid" }));
    return false;
  };

  const handleGenerateInvoice = () => {
    // Extract type value - handle both primitive and object formats
    const rawType = invoiceSelection.type;
    const typeValue = typeof rawType === "string" ? rawType : (rawType as any)?.value || "";
    
    // Extract month value - handle both primitive and object formats
    const rawMonth = invoiceSelection.monthName;
    const monthName = typeof rawMonth === "string" ? rawMonth : (rawMonth as any)?.value || "";
    
    const { year } = invoiceSelection;
    
    if (!validateInvoiceSelection(typeValue, year, monthName)) {
      return;
    }
    const monthIndex = getMonthIndex(monthName);
    const fromTime = new Date(year, monthIndex, 1, 0, 0, 0, 0).getTime();
    const tillTime = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999).getTime();
    props.onGenerateInvoice?.({
      type: typeValue,
      year,
      month: monthIndex + 1,
      fromTime,
      tillTime,
    });
  };
  // const countries = [
  //   { label: "India", value: "+91", code: "in" },
  //   { label: "Singapore", value: "+65", code: "sg" },
  //   { label: "Malaysia", value: "+60", code: "my" },
  // ];
  const [value, setValue] = useState<TextBoxProps["value"]>("sdf ");
  const [formKey, setFormKey] = React.useState(1);
  const [countryCode, setCountryCode] = useState<any>("");

  const mobileValidator =
    props.formType === "NEW"
      ? validators.mobileNumberValidator
      : validators.mobileNumberEditValidator;

  // Fix: Use string keys directly instead of CountryProperty enum
  const myCountryCodesObject = countryCodes?.customList(
    "countryCode",
    "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  );
  const myCountryCodesArray = Object.entries(myCountryCodesObject).map(
    ([key, value]) => value
  );

  console.log("my country code object", myCountryCodesObject);
  console.log("myCountryCodesArray", myCountryCodesArray);

  const extractedData = myCountryCodesArray.map((item: any) => {
    const [countryCodeSome, rest] = item.split("]");
    const [countryNameEn, countryCallingCode] = rest.split(": +");

    return {
      countryCode: countryCodeSome.slice(1),
      countryNameEn,
      item,
      countryCallingCode: `+${countryCallingCode}`,
    };
  });

  const countryList = extractedData.map((item) => {
    return {
      label: item.item,
      value: item.item,
      code: item.countryCode.toLowerCase(),
      countryName: item.countryNameEn,
      countryCallingCode: item.countryCallingCode,
    };
  });
  useEffect(() => {
    console.log("inside use effect ,organization form");
    let initialValuesData = {};
    console.log(props.formType);
    if (props.formType === "EDIT") {
      console.log("validval", props?.customerData?.validUpTo);
      if (props.customerData) {
        console.log("1");
        setSavebutton(false);
        settoggle(true);

        const existingInvoiceYear =
          props?.customerData?.invoiceConfig?.year || defaultInvoiceYear;
        const existingInvoiceMonth = getMonthName(
          props?.customerData?.invoiceConfig?.month
        );
        const allowedForExistingYear =
          invoiceMonthOptions(existingInvoiceYear || defaultInvoiceYear);
        const safeExistingInvoiceMonth = allowedForExistingYear.find(
          (m) => m.value === existingInvoiceMonth
        )?.value;
        if (existingInvoiceYear) {
          setSelectedInvoiceYear(existingInvoiceYear);
        }

        initialValuesData = {
          orgName: props.customerData.organizationName,
          legalName: props.customerData.legalName,
          addrLine1: props.customerData.address.add1,
          addrLine2: props.customerData.address.add2,
          city: props.customerData.address.city,
          country: props.customerData.address.country,
          state: props.customerData.address.state,
          phNo: props.customerData.phNo,
          zipCode: props.customerData.address.zipcode,
          email: props.customerData.email,
          whatAccessToken: props.customerData.whatAccessToken,
          teamAccessToken: props.customerData.teamAccessToken,
          slackAccessToken: props.customerData.slackAccessToken,
          emailAccessToken: props.customerData.emailAccessToken,
          status: props.customerData.status,
          tax: props.customerData.tax,
          validUpTo: props.customerData.validUpTo,
          aiModel: complexSimpleModelMapping[props.customerData.aiModel],
          analytics: analyticsValues[props.customerData.analytics],
          logo: props.customerData.logo || previousLogoName,
          nameOfSigner1:
            props?.customerData?.featureAccess?.certification_details?.sign1
              ?.signerName,
          signature1:
            props?.customerData?.featureAccess?.certification_details?.sign1
              ?.signUrl,

          roleOfSigner1:
            props?.customerData?.featureAccess?.certification_details?.sign1
              ?.signerRole,

          nameOfSigner2:
            props?.customerData?.featureAccess?.certification_details?.sign2
              ?.signerName,
          signature2:
            props?.customerData?.featureAccess?.certification_details?.sign2
              ?.signUrl,
          roleOfSigner2:
            props?.customerData?.featureAccess?.certification_details?.sign2
              ?.signerRole,
          invoiceType: props?.customerData?.invoiceConfig?.type || "",
          invoiceYear: existingInvoiceYear,
          invoiceMonth:
            safeExistingInvoiceMonth ||
            getAllowedMonths(existingInvoiceYear || defaultInvoiceYear)[0] ||
            "",
          // Pricing fields
          pricePerTotalUser: props?.customerData?.pricingConfig?.pricePerTotalUser || 0,
          pricePerActiveUser: props?.customerData?.pricingConfig?.pricePerActiveUser || 0,
          pricePerCardToActive: props?.customerData?.pricingConfig?.pricePerCardToActive || 0,
          discountPercent: props?.customerData?.pricingConfig?.discountPercent || 0,
        };
        setInvoiceSelection({
          type: props?.customerData?.invoiceConfig?.type || "",
          year: existingInvoiceYear,
          monthName:
            safeExistingInvoiceMonth ||
            getAllowedMonths(existingInvoiceYear || defaultInvoiceYear)[0] ||
            "",
        });
        // Update pricing config from customer data
        setPricingConfig({
          pricePerTotalUser: props?.customerData?.pricingConfig?.pricePerTotalUser || 0,
          pricePerActiveUser: props?.customerData?.pricingConfig?.pricePerActiveUser || 0,
          pricePerCardToActive: props?.customerData?.pricingConfig?.pricePerCardToActive || 0,
          discountPercent: props?.customerData?.pricingConfig?.discountPercent || 0,
        });
        checkboxStates.whatsappCheck = props.customerData.whatsapp;
        checkboxStates.teamsCheck = props.customerData.teams;
        checkboxStates.slackCheck = props.customerData.slack;
        checkboxStates.emailCheck = props.customerData.emailCheck;

        features.analyticsCheck = props?.customerData?.analytics;
        features.auditCheck = props?.customerData?.featureAccess?.audit;
        features.certificationCheck =
          props?.customerData?.featureAccess?.certification;

        setSavebutton(false);

        setShowNewOragnization(initialValuesData);
        console.log("at exit of use effect");
        console.log("initalval customer data EDIT", initialValuesData);
      }
    } else if (props.formType === "NEW") {
      // Don't set default year - user must select year first
      // setSelectedInvoiceYear(defaultInvoiceYear);
      const defaultMonths = getAllowedMonths(defaultInvoiceYear);
      initialValuesData = {
        orgName: "",
        legalName: "",
        addrLine1: "",
        addrLine2: "",
        city: "",
        country: intl.formatMessage({ id: "countryVal" }),
        state: "",
        phNo: "",
        zipCode: "",
        email: "",
        whatAccessToken: "",
        teamAccessToken: "",
        slackAccessToken: "",
        emailAccessToken: "",
        status: intl.formatMessage({ id: "personal.enabled" }),
        tax: "",
        validUpTo: "",
        aiModel: intl.formatMessage({ id: "gpt3p5val" }),
        analytics: intl.formatMessage({ id: "personal.enabled" }),
        invoiceType: "",
        invoiceYear: defaultInvoiceYear,
        invoiceMonth:
          defaultMonths[defaultMonths.length - 1] ||
          defaultMonths[0] ||
          "",
        // Pricing fields (default zeros for new org)
        pricePerTotalUser: 0,
        pricePerActiveUser: 0,
        pricePerCardToActive: 0,
        discountPercent: 0,
      };
      setInvoiceSelection({
        type: "",
        year: defaultInvoiceYear,
        monthName:
          defaultMonths[defaultMonths.length - 1] ||
          defaultMonths[0] ||
          "",
      });
      console.log(
        "initalval customer data for form type NEW",
        initialValuesData
      );

      setSavebutton(true);
      settoggle(true);
      setShowNewOragnization(initialValuesData);
    }
  }, [props.customerData, props.formType]);

  return (
    <div>
      <div className="mb-4"></div>
      <div className="text-mk-primary-bright text-xl font-bold">
        <FormattedMessage id="organization.organization.organizationDetails" />
      </div>
      <div>
        {showtoggle && (
          <Form
            initialValues={showNewOragnization}
            key={formKey}
            onSubmit={signIn}
            render={(formRenderprops) => (
              <FormElement>
                <div className="grid grid-cols-2">
                  <div>
                    <div>
                      <Field
                        name={"orgName"}
                        id={"orgName"}
                        label={intl.formatMessage({
                          id: "organizationForm.orgName",
                        })}
                        component={FormMaskedTextBox}
                        validator={validators.orgRegexValidator}
                        className="bg-white w-96 my-1"
                        maxLength={50}
                      />
                    </div>

                    <div>
                      <Field
                        name={"addrLine1"}
                        id={"addrLine1"}
                        label={intl.formatMessage({
                          id: "organizationForm.billingAddress",
                        })}
                        component={FormMaskedTextBox}
                        maxLength={50}
                        className="bg-white w-96"
                        validator={validators.addrLine1Validator}
                        placeholder="Address Line 1"
                      />
                    </div>

                    <div>
                      <Field
                        name={"addrLine2"}
                        id={"addrLine2"}
                        component={FormMaskedTextBox}
                        maxLength={50}
                        placeholder={intl.formatMessage({
                          id: "organizationForm.addressLine2",
                        })}
                        className="bg-white w-96 my-1"
                        validator={validators.addrLine2Validator}
                      />
                    </div>

                    <div>
                      <Field
                        name={"city"}
                        id={"city"}
                        component={FormMaskedTextBox}
                        maxLength={50}
                        placeholder={intl.formatMessage({
                          id: "organizationForm.city",
                        })}
                        className="bg-white w-96 my-1"
                        validator={validators.cityValidator}
                      />
                    </div>

                    <div>
                      <Field
                        name={"state"}
                        id={"state"}
                        component={FormMaskedTextBox}
                        maxLength={50}
                        placeholder={intl.formatMessage({
                          id: "organizationForm.state",
                        })}
                        className="bg-white w-96 my-1"
                        validator={validators.stateValidator}
                      />
                    </div>

                    <div>
                      <Field
                        name={"country"}
                        id={"country"}
                        component={FormDropDownList}
                        placeholder={intl.formatMessage({
                          id: "organizationForm.country",
                        })}
                        data={countryNameList}
                        defaultValue={intl.formatMessage({
                          id: "organizationForm.country",
                        })}
                        // className="bg-white w-96 my-1"
                        className="bg-white w-96"
                      />
                    </div>

                    <div>
                      <Field
                        name={"zipCode"}
                        id={"zipCode"}
                        value={intl.formatMessage({
                          id: "organizationForm.zipCode",
                        })}
                        component={FormMaskedTextBox}
                        placeholder={intl.formatMessage({
                          id: "organizationForm.zipCode",
                        })}
                        maxLength={50}
                        className="bg-white w-96 my-1"
                      />
                    </div>

                    <div>
                      <Field
                        name={"email"}
                        id={"email"}
                        label={intl.formatMessage({
                          id: "organizationForm.contactDetails",
                        })}
                        component={FormMaskedTextBox}
                        validator={validators.emailValidator}
                        maxLength={50}
                        className="bg-white w-96 my-1"
                        placeholder={intl.formatMessage({
                          id: "emailPlaceholder",
                        })}
                      />
                    </div>

                    {props.formType === "NEW" ? (
                      <div>
                        <div className="flex items-end">
                          <InputPicker
                            cleanable={false}
                            size="sm"
                            style={{
                              width: 102,
                              display: "inline-block",
                              border: "1px solid var(--color-mk-primary)",
                              borderRadius: "4px",
                            }}
                            className="bg-white w-96"
                            onChange={setCountryCode}
                            // @ts-ignore
                            data={countryList}
                            renderValue={(value, item: any) => {
                              return (
                                <div className="bg-white w-96">
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  {item?.countryCallingCode}
                                </div>
                              );
                            }}
                            renderMenuItem={(label, item) => {
                              return (
                                <div>
                                  <p></p>
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  &nbsp;
                                  {`${item?.countryName} (${item?.countryCallingCode})`}
                                </div>
                              );
                            }}
                          />

                          <Field
                            name={"phNo"}
                            id={"phNo"}
                            label={<CustomMobileLabel />}
                            maxLength={15}
                            component={FormMaskedTextBoxMobile}
                            validator={validators.mobileNumberValidator}
                            className="bg-white w-72"
                          />
                        </div>
                        <Error>{errors.noCountryCode?.error}</Error>
                      </div>
                    ) : (
                      <Field
                        name={"phNo"}
                        id={"phNo"}
                        label={intl.formatMessage({
                          id: "organization.mobileNum",
                        })}
                        maxLength={15}
                        component={FormMaskedTextBox}
                        validator={validators.mobileNumberUpdateValidator}
                        className="bg-white w-96"
                      />
                    )}
                    <div>
                      <Field
                        name={"status"}
                        id={"status"}
                        label={intl.formatMessage({
                          id: "organization.status",
                        })}
                        component={FormDropDownList}
                        className="bg-white w-40"
                        data={[intl.formatMessage({ id: "diabledVal" })]}
                        defaultValue={intl.formatMessage({ id: "enabledVal" })}
                      />
                    </div>
                  </div>

                  <div>
                    <div>
                      <Field
                        name={"legalName"}
                        id={"legalName"}
                        label={intl.formatMessage({
                          id: "organization.legalName",
                        })}
                        value={value}
                        component={FormMaskedTextBox}
                        validator={validators.legalNameRegexValidator}
                        onChange={(e: any) => {
                          const inputValue = e.value;
                          console.log("empId valu", inputValue);
                        }}
                        className="bg-white w-96"
                        maxLength={50}
                      />
                    </div>
                    {/* <div>
                      <Field
                        name={"distAccess"}
                        id={"distAcess"}
                        label={intl.formatMessage({
                          id: "organization.distAccess",
                        })}
                        value={value}
                        // component={FormInput}
                        component={FormMaskedTextBox}
                        style={{ opacity: 0, position: "absolute" }}
                        maxLength={50}
                        disabled
                      />
                    </div> */}

                    <div className="mt-5">
                      {intl.formatMessage({
                        id: "organization.distAccess",
                      })}
                    </div>

                    <div className="flex items-center">
                      <div className="w-[20%]">
                        <Field
                          name={"whatsapp"}
                          id={"whatsapp"}
                          label={intl.formatMessage({ id: "whatsAppLabel" })}
                          component={FormCheckbox}
                          checked={checkboxStates.whatsappCheck}
                          onChange={() => handleCheckboxChange("whatsappCheck")}
                        />
                      </div>
                      <div className="w-[80%]">
                        <Field
                          name={"whatAccessToken"}
                          id={"whatAccessToken"}
                          component={FormMaskedTextBox}
                          maxLength={20}
                          className="w-56"
                          placeholder={intl.formatMessage({
                            id: "accessTokenPlaceholder",
                          })}
                          disabled={!checkboxStates.whatsappCheck}
                        />
                      </div>
                    </div>

                    <div className="flex items-center ">
                      <div className="w-[20%]">
                        <Field
                          name={"teams"}
                          id={"teams"}
                          label={intl.formatMessage({ id: "teamsLabel" })}
                          component={FormCheckbox}
                          checked={checkboxStates.teamsCheck}
                          onChange={() => handleCheckboxChange("teamsCheck")}
                        />
                      </div>

                      <div className="w-[80%]">
                        <Field
                          name={"teamAccessToken"}
                          id={"teamAccessToken"}
                          component={FormMaskedTextBox}
                          maxLength={20}
                          className="w-56"
                          placeholder={intl.formatMessage({
                            id: "accessTokenPlaceholder",
                          })}
                          disabled={!checkboxStates.teamsCheck}
                        />
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-[20%]">
                        <Field
                          name={"slack"}
                          id={"slack"}
                          label={intl.formatMessage({ id: "slackLabel" })}
                          component={FormCheckbox}
                          checked={checkboxStates.slackCheck}
                          onChange={() => handleCheckboxChange("slackCheck")}
                        />
                      </div>

                      <div className="w-[80%]">
                        <Field
                          name={"slackAccessToken"}
                          id={"slackAccessToken"}
                          component={FormMaskedTextBox}
                          maxLength={20}
                          className="w-56"
                          placeholder={intl.formatMessage({
                            id: "accessTokenPlaceholder",
                          })}
                          disabled={!checkboxStates.slackCheck}
                        />
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-[20%]">
                        <Field
                          name={"emailCheck"}
                          id={"emailCheck"}
                          label={intl.formatMessage({ id: "emailLabel" })}
                          component={FormCheckbox}
                          checked={checkboxStates.emailCheck}
                          onChange={() => handleCheckboxChange("emailCheck")}
                        />
                      </div>

                      <div className="w-[80%]">
                        <Field
                          name={"emailAccessToken"}
                          id={"emailAccessToken"}
                          component={FormMaskedTextBox}
                          maxLength={20}
                          className="w-56"
                          placeholder={intl.formatMessage({
                            id: "accessTokenPlaceholder",
                          })}
                          disabled={!checkboxStates.emailCheck}
                        />
                      </div>
                    </div>

                    <div>
                      <Field
                        name={"aiModel"}
                        id={"aiModel"}
                        label={intl.formatMessage({ id: "aiModel" })}
                        data={[
                          intl.formatMessage({ id: "gpt4oval" }),
                          intl.formatMessage({ id: "gpt4val" }),
                        ]}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        defaultValue={intl.formatMessage({ id: "gpt3p5val" })}
                      />
                    </div>

                    <div>
                      <Field
                        name={"validUpTo"}
                        id={"validUpTo"}
                        label={intl.formatMessage({
                          id: "organization.validUntil",
                        })}
                        component={FormDatePicker}
                        className="bg-white w-40"
                        validator={validators.dateValidator}
                      />
                    </div>

                    <div>
                      <Field
                        name={"tax"}
                        id={"tax"}
                        label={intl.formatMessage({ id: "organization.tax" })}
                        component={FormMaskedTextBox}
                        className="bg-white w-40"
                        maxLength={50}
                      />
                    </div>

                    <div className="mt-5">
                      {intl.formatMessage({
                        id: "organization.featureAccess",
                      })}
                      {/* <Field
                        name={"features"}
                        id={"features"}
                        label={intl.formatMessage({
                          id: "organization.featureAccess",
                        })}
                        value={value}
                        component={FormMaskedTextBox}
                        // style={{ opacity: 0, position: "absolute" }}
                        maxLength={50}
                        disabled
                      /> */}
                    </div>

                    <div className="w-[20%]">
                      <Field
                        name={"analytics"}
                        id={"analytics"}
                        label={intl.formatMessage({
                          id: "organization.analytics",
                        })}
                        component={FormCheckbox}
                        checked={features.analyticsCheck}
                        onChange={() => handleFeatureAccess("analyticsCheck")}
                      />
                    </div>

                    {props.formType === "EDIT" && (
                      <div>
                        <div>
                          <Field
                            name={"audit"}
                            id={"audit"}
                            label={intl.formatMessage({
                              id: "organization.auditRequired",
                            })}
                            component={FormCheckbox}
                            checked={features.auditCheck}
                            onChange={() => handleFeatureAccess("auditCheck")}
                          />
                        </div>

                        <div>
                          <Field
                            name={"certification"}
                            id={"certification"}
                            label={intl.formatMessage({
                              id: "organization.certificateRequired",
                            })}
                            component={FormCheckbox}
                            checked={features.certificationCheck}
                            onChange={() =>
                              handleFeatureAccess("certificationCheck")
                            }
                          />
                        </div>

                        {features.certificationCheck && (
                          <div className="mt-4 rounded-lg border border-mk-light-grey bg-white shadow-md p-5 space-y-4">
                            <div
                              className="flex items-center justify-between cursor-pointer"
                              onClick={() =>
                                setIsCertificationCollapsed(
                                  !isCertificationCollapsed
                                )
                              }
                            >
                              <div className="flex flex-col gap-1">
                                <div className="text-mk-primary-bright text-lg font-semibold">
                                  <FormattedMessage id="organization.certificateDetails" />
                                </div>
                              </div>
                              <span className={`transform transition-transform duration-200 ${isCertificationCollapsed ? '' : 'rotate-180'}`}>
                                ▼
                              </span>
                            </div>

                            {!isCertificationCollapsed && (
                              <div className="pt-4 border-t border-mk-light-grey">
                                <div>
                                  <div className="flex items-end space-x-2">
                                    <div>
                                      <Field
                                        name={"logo"}
                                        id={"logo"}
                                        label={intl.formatMessage({
                                          id: "organization.logo",
                                        })}
                                        component={FormFileUpload}
                                        optional={true}
                                        validationMessage={intl.formatMessage({
                                          id: "organization.valideLogo",
                                        })}
                                        accountId={props?.customerData?.accntId}
                                        buttonText={intl.formatMessage({
                                          id: "organization.uploadLogoButton",
                                        })}
                                        infoText={
                                          <>
                                            {intl.formatMessage({
                                              id: "organization.uploadLogoInfo",
                                            })}{" "}
                                          </>
                                        }
                                        // selectedFileName={
                                        //   props?.customerData?.logo
                                        // }
                                        selectedFileName={props?.customerData?.logo
                                          .split("/")
                                          .pop()}
                                        disabled={!features.certificationCheck}
                                        onChange={(data) => {
                                          console.log(
                                            "Deserialized data",
                                            data
                                          );
                                          console.log(
                                            "logo initial",
                                            props?.customerData?.logo
                                          );

                                          setFileData(data?.target?.name);
                                          setPreviousLogoName(
                                            data?.target?.name
                                          );
                                          console.log(
                                            "print previous logo name",
                                            previousLogoName
                                          );
                                          if (props.uploadFileToS3) {
                                            props.uploadFileToS3(
                                              data,
                                              props?.customerData?.accntId,
                                              "logo",
                                              previousLogoName ||
                                                props?.customerData?.logo
                                            );
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <strong></strong>
                                      {fileData}
                                    </div>
                                  </div>
                                  <div className="">
                                    <div>
                                      <Field
                                        name={"nameOfSigner1"}
                                        id={"nameOfSigner1"}
                                        label={intl.formatMessage({
                                          id: "organization.signature1",
                                        })}
                                        component={FormMaskedTextBox}
                                        placeholder={intl.formatMessage({
                                          id: "organization.sign1Placeholder",
                                        })}
                                        maxLength={50}
                                        className="bg-white w-96 my-1"
                                        disabled={!features.certificationCheck}
                                      />
                                    </div>

                                    <div>
                                      <Field
                                        name={"roleOfSigner1"}
                                        id={"roleOfSigner1"}
                                        component={FormMaskedTextBox}
                                        maxLength={50}
                                        placeholder={intl.formatMessage({
                                          id: "organization.rolePlaceholder",
                                        })}
                                        validationMessage={intl.formatMessage({
                                          id: "organization.roleValidation",
                                        })}
                                        className="bg-white w-96 "
                                        disabled={!features.certificationCheck}
                                      />
                                    </div>
                                    <div className="flex items-end space-x-2">
                                      <Field
                                        name={"signature1"}
                                        id={"signature1"}
                                        component={FormFileUpload}
                                        validateDimensions={true}
                                        minWidthHeightRatio={1.2}
                                        validationMessage={intl.formatMessage({
                                          id: "organization.signature2ValidationFile",
                                        })}
                                        accountId={props?.customerData?.accntId}
                                        buttonText={intl.formatMessage({
                                          id: "organization.uploadSign1Button",
                                        })}
                                        infoText={
                                          <>
                                            {intl.formatMessage({
                                              id: "organization.uploadSign1Info",
                                            })}{" "}
                                          </>
                                        }
                                        disabled={!features.certificationCheck}
                                        // selectedFileName={
                                        //   props?.customerData?.featureAccess
                                        //     ?.certification_details?.sign1
                                        //     ?.signUrl
                                        // }
                                        selectedFileName={props?.customerData?.featureAccess?.certification_details?.sign1?.signUrl
                                          .split("/")
                                          .pop()}
                                        onChange={(data) => {
                                          console.log(
                                            "Deserialized data for signature 1",
                                            data
                                          );
                                          console.log(
                                            "signature initial",
                                            props?.customerData?.featureAccess
                                              ?.certification_details?.sign1
                                              ?.signUrl
                                          );

                                          setSignature1(data?.target?.name);
                                          setPreviousSignature1(
                                            data?.target?.name
                                          );
                                          console.log(
                                            "print previous signature 1 name",
                                            previousSignature1
                                          );
                                          if (props.uploadFileToS3) {
                                            props.uploadFileToS3(
                                              data,
                                              props?.customerData?.accntId,
                                              "signature1",
                                              previousSignature1 ||
                                                props?.customerData
                                                  ?.featureAccess
                                                  ?.certification_details?.sign1
                                                  ?.signUrl
                                            );
                                          }
                                        }}
                                      />

                                      <div className="mt-2">
                                        <strong></strong>

                                        {signature1}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <Field
                                    name={"nameOfSigner2"}
                                    id={"nameOfSigner2"}
                                    label={intl.formatMessage({
                                      id: "organization.signature2",
                                    })}
                                    maxLength={50}
                                    component={FormMaskedTextBox}
                                    optional={false}
                                    placeholder={intl.formatMessage({
                                      id: "organization.signature2Placeholder",
                                    })}
                                    validationMessage={intl.formatMessage({
                                      id: "organization.signature2Validation",
                                    })}
                                    className="bg-white w-96"
                                    disabled={!features.certificationCheck}
                                  />
                                </div>

                                <div>
                                  <Field
                                    name={"roleOfSigner2"}
                                    id={"roleOfSigner2"}
                                    maxLength={50}
                                    component={FormMaskedTextBox}
                                    optional={false}
                                    placeholder={intl.formatMessage({
                                      id: "organization.role2Placeholder",
                                    })}
                                    validationMessage={intl.formatMessage({
                                      id: "organization.roleValidation",
                                    })}
                                    className="bg-white w-96"
                                    disabled={!features.certificationCheck}
                                  />
                                </div>
                                <div className="flex items-end space-x-2">
                                  <div>
                                    <Field
                                      name={"signature2"}
                                      id={"signature2"}
                                      component={FormFileUpload}
                                      validateDimensions={true}
                                      minWidthHeightRatio={1.2}
                                      optional={false}
                                      validationMessage={intl.formatMessage({
                                        id: "organization.signature2ValidationFile",
                                      })}
                                      accountId={props?.customerData?.accntId}
                                      buttonText={intl.formatMessage({
                                        id: "organization.sign2Button",
                                      })}
                                      infoText={
                                        <>
                                          {intl.formatMessage({
                                            id: "organization.sign2Info",
                                          })}{" "}
                                        </>
                                      }
                                      // selectedFileName={
                                      //   props?.customerData?.featureAccess
                                      //     ?.certification_details?.sign2
                                      //     ?.signUrl
                                      // }
                                      selectedFileName={props?.customerData?.featureAccess?.certification_details?.sign2?.signUrl
                                        .split("/")
                                        .pop()}
                                      disabled={!features.certificationCheck}
                                      onChange={(data) => {
                                        console.log(
                                          "Deserialized data for signature 2",
                                          data
                                        );
                                        console.log(
                                          "signature initial 2",
                                          props?.customerData?.featureAccess
                                            ?.certification_details?.sign2
                                            ?.signUrl
                                        );

                                        setSignature2(data?.target?.name);
                                        setPreviousSignature2(
                                          data?.target?.name
                                        );
                                        console.log(
                                          "print previous signature 2 name",
                                          previousSignature2
                                        );
                                        if (props.uploadFileToS3) {
                                          props.uploadFileToS3(
                                            data,
                                            props?.customerData?.accntId,
                                            "signature2",
                                            previousSignature2 ||
                                              props?.customerData?.featureAccess
                                                ?.certification_details?.sign2
                                                ?.signUrl
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                  <div className="mt-2">
                                    <strong></strong>

                                    {signature2}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Pricing Configuration Section - Admin only */}
                    {isAdmin && (
                    <div className="mt-8 rounded-lg border border-mk-light-grey bg-white shadow-md p-5 space-y-4">
                      <div 
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => setIsPricingCollapsed(!isPricingCollapsed)}
                      >
                        <div className="flex flex-col gap-1">
                          <div className="text-mk-primary-bright text-lg font-semibold">
                            <FormattedMessage id="organization.pricingSectionTitle" />
                          </div>
                          <div className="text-sm text-mk-dark-grey">
                            <FormattedMessage id={isAdmin ? "organization.pricingSectionSubtitleAdmin" : "organization.pricingSectionSubtitleTenant"} />
                          </div>
                        </div>
                        <span className={`transform transition-transform duration-200 ${isPricingCollapsed ? '' : 'rotate-180'}`}>
                          ▼
                        </span>
                      </div>

                      {!isPricingCollapsed && (
                        <>
                      {isAdmin ? (
                        /* Admin: Editable pricing inputs */
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-mk-light-grey">
                          <Field
                            name={"pricePerTotalUser"}
                            id={"pricePerTotalUser"}
                            label={intl.formatMessage({
                              id: "organization.pricePerTotalUser",
                            })}
                            component={FormNumericTextBox}
                            min={0}
                            format="n0"
                            className="bg-white w-full"
                          />
                          <Field
                            name={"pricePerActiveUser"}
                            id={"pricePerActiveUser"}
                            label={intl.formatMessage({
                              id: "organization.pricePerActiveUser",
                            })}
                            component={FormNumericTextBox}
                            min={0}
                            format="n0"
                            className="bg-white w-full"
                          />
                          <Field
                            name={"pricePerCardToActive"}
                            id={"pricePerCardToActive"}
                            label={intl.formatMessage({
                              id: "organization.pricePerCardToActive",
                            })}
                            component={FormNumericTextBox}
                            min={0}
                            format="n0"
                            className="bg-white w-full"
                          />
                          <Field
                            name={"discountPercent"}
                            id={"discountPercent"}
                            label={intl.formatMessage({
                              id: "organization.discountPercent",
                            })}
                            component={FormNumericTextBox}
                            min={0}
                            max={100}
                            format="n0"
                            className="bg-white w-full"
                          />
                        </div>
                      ) : (
                        /* Tenant: Read-only pricing chart */
                        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-lg p-6 mt-4 border-t border-mk-light-grey pt-6">
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            {/* Price per Total User */}
                            <div className="bg-white rounded-lg shadow-sm p-4 border border-slate-200">
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                                  <span className="text-blue-600 text-lg">👥</span>
                                </div>
                                <div>
                                  <div className="text-xs text-slate-500 uppercase tracking-wide">
                                    <FormattedMessage id="organization.pricePerTotalUserLabel" />
                                  </div>
                                  <div className="text-xl font-bold text-slate-800">
                                    ₹{pricingConfig.pricePerTotalUser.toLocaleString()}
                                  </div>
                                  <div className="text-xs text-slate-400">
                                    <FormattedMessage id="organization.perUserPerMonth" />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Price per Active User */}
                            <div className="bg-white rounded-lg shadow-sm p-4 border border-slate-200">
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                                  <span className="text-green-600 text-lg">✓</span>
                                </div>
                                <div>
                                  <div className="text-xs text-slate-500 uppercase tracking-wide">
                                    <FormattedMessage id="organization.pricePerActiveUserLabel" />
                                  </div>
                                  <div className="text-xl font-bold text-slate-800">
                                    ₹{pricingConfig.pricePerActiveUser.toLocaleString()}
                                  </div>
                                  <div className="text-xs text-slate-400">
                                    <FormattedMessage id="organization.perUserPerMonth" />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Price per Card to Active */}
                            <div className="bg-white rounded-lg shadow-sm p-4 border border-slate-200">
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center">
                                  <span className="text-purple-600 text-lg">📧</span>
                                </div>
                                <div>
                                  <div className="text-xs text-slate-500 uppercase tracking-wide">
                                    <FormattedMessage id="organization.pricePerCardLabel" />
                                  </div>
                                  <div className="text-xl font-bold text-slate-800">
                                    ₹{pricingConfig.pricePerCardToActive.toLocaleString()}
                                  </div>
                                  <div className="text-xs text-slate-400">
                                    <FormattedMessage id="organization.perCardSent" />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Discount */}
                            <div className="bg-white rounded-lg shadow-sm p-4 border border-slate-200">
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                                  <span className="text-amber-600 text-lg">🏷️</span>
                                </div>
                                <div>
                                  <div className="text-xs text-slate-500 uppercase tracking-wide">
                                    <FormattedMessage id="organization.discountLabel" />
                                  </div>
                                  <div className="text-xl font-bold text-emerald-600">
                                    {pricingConfig.discountPercent}%
                                  </div>
                                  <div className="text-xs text-slate-400">
                                    <FormattedMessage id="organization.discountApplied" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Pricing summary note */}
                          <div className="mt-4 pt-4 border-t border-slate-200">
                            <div className="text-sm text-slate-600 flex items-center gap-2">
                              <span className="text-blue-500">ℹ️</span>
                              <FormattedMessage id="organization.pricingNote" />
                            </div>
                          </div>
                        </div>
                      )}
                        </>
                      )}
                    </div>
                    )}

                    {/* Invoice generation - Admin only */}
                    {isAdmin && (
                    <div className="mt-8 rounded-lg border border-mk-light-grey bg-white shadow-md p-5 space-y-4">
                      <div 
                        className="flex items-center justify-between cursor-pointer"
                        onClick={() => setIsInvoiceCollapsed(!isInvoiceCollapsed)}
                      >
                        <div className="flex flex-col gap-1">
                          <div className="text-mk-primary-bright text-lg font-semibold">
                            <FormattedMessage id="organization.invoiceSectionTitle" />
                          </div>
                          <div className="text-sm text-mk-dark-grey">
                            <FormattedMessage id="organization.invoiceSectionSubtitle" />
                          </div>
                        </div>
                        <div className="flex items-center gap-4">
                          {invoiceError && (
                            <div className="text-red-600 text-sm font-medium">
                              {invoiceError}
                            </div>
                          )}
                          <span className={`transform transition-transform duration-200 ${isInvoiceCollapsed ? '' : 'rotate-180'}`}>
                            ▼
                          </span>
                        </div>
                      </div>
                      
                      {!isInvoiceCollapsed && (
                        <>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-mk-light-grey">
                        <Field
                          name={"invoiceType"}
                          component={(fieldRenderProps: any) => (
                            <FormDropDownList
                              {...fieldRenderProps}
                          id={"invoiceType"}
                          label={intl.formatMessage({
                            id: "organization.invoiceTypeLabel",
                          })}
                          data={invoiceTypeOptions}
                          textField={"text"}
                          dataItemKey={"value"}
                          valuePrimitive={true}
                          className="bg-white w-full"
                          defaultValue={{
                            text: intl.formatMessage({
                              id: "organization.invoiceTypePlaceholder",
                            }),
                            value: "",
                          }}
                              onChange={(ev: any) => {
                                // Extract type value - handle both primitive and object {text, value} formats
                                let nextType: string;
                                if (typeof ev.value === "string") {
                                  nextType = ev.value;
                                } else if (typeof ev.value === "object" && ev.value !== null && ev.value.value !== undefined) {
                                  nextType = ev.value.value;
                                } else {
                                  nextType = ev.target?.value || ev?.dataItem?.value || "";
                                }
                                setInvoiceSelection((prev) => ({
                                  ...prev,
                                  type: nextType,
                                }));
                                fieldRenderProps.onChange(ev);
                              }}
                            />
                          )}
                        />

                        <Field
                          name={"invoiceYear"}
                          component={(fieldRenderProps: any) => (
                            <FormDropDownList
                              {...fieldRenderProps}
                              id={"invoiceYear"}
                              label={intl.formatMessage({
                                id: "organization.invoiceYearLabel",
                              })}
                              data={invoiceYearOptions}
                              textField="text"
                              dataItemKey="value"
                              valuePrimitive={true}
                              className="bg-white w-full"
                              defaultValue={{
                                text: intl.formatMessage({
                                id: "organization.invoiceYearPlaceholder",
                                }),
                                value: "",
                              }}
                              onChange={(ev: any) => {
                                // Extract year value - handle both primitive and object {text, value} formats
                                let yr: number;
                                if (typeof ev.value === "number") {
                                  yr = ev.value;
                                } else if (typeof ev.value === "object" && ev.value !== null && ev.value.value !== undefined) {
                                  // Handle Kendo DropDownList object format {text: "2024", value: 2024}
                                  yr = typeof ev.value.value === "number" ? ev.value.value : Number(ev.value.value);
                                } else {
                                  yr = Number(ev.value || ev.target?.value);
                                }
                                
                                if (!isNaN(yr)) {
                                  setSelectedInvoiceYear(yr);
                                  const allowed = getAllowedMonths(yr);
                                  const currentMonth = invoiceSelection.monthName;
                                  // Check if current month is valid for the new year
                                  const isCurrentMonthValid = currentMonth && allowed.includes(currentMonth);
                                  
                                  if (!isCurrentMonthValid) {
                                    // Reset to last available month for the new year
                                    const newMonth = allowed[allowed.length - 1] || allowed[0] || "";
                                    setInvoiceSelection((prev) => ({
                                      ...prev,
                                      year: yr,
                                      monthName: newMonth,
                                    }));
                                    // Update the invoiceMonth field in the form
                                    formRenderprops.onChange("invoiceMonth", { value: newMonth });
                                  } else {
                                    // Keep current month, just update year
                                    setInvoiceSelection((prev) => ({
                                      ...prev,
                                      year: yr,
                                    }));
                                  }
                                }
                                fieldRenderProps.onChange(ev);
                              }}
                            />
                          )}
                        />

                        <Field
                          name={"invoiceMonth"}
                          component={(fieldRenderProps: any) => {
                            // Use selectedInvoiceYear state - it's updated when year changes
                            const isYearSelected = selectedInvoiceYear !== undefined && selectedInvoiceYear !== null && !isNaN(Number(selectedInvoiceYear));
                            const yearValue = isYearSelected ? Number(selectedInvoiceYear) : undefined;
                            const monthOptions = isYearSelected ? invoiceMonthOptions(yearValue) : [];
                            
                            return (
                              <FormDropDownList
                                {...fieldRenderProps}
                                id={"invoiceMonth"}
                                label={intl.formatMessage({
                                  id: "organization.invoiceMonthLabel",
                                })}
                                data={monthOptions}
                                textField="text"
                                dataItemKey="value"
                                valuePrimitive={true}
                                className="bg-white w-full"
                                disabled={!isYearSelected}
                                defaultValue={{
                                  text: intl.formatMessage({
                                    id: "organization.invoiceMonthPlaceholder",
                                  }),
                                  value: "",
                                }}
                                onChange={(ev: any) => {
                                  // Extract month value - handle both primitive and object {text, value} formats
                                  let nextMonth: string;
                                  if (typeof ev.value === "string") {
                                    nextMonth = ev.value;
                                  } else if (typeof ev.value === "object" && ev.value !== null && ev.value.value !== undefined) {
                                    nextMonth = ev.value.value;
                                  } else {
                                    nextMonth = ev.target?.value || ev?.dataItem?.value || "";
                                  }
                                  setInvoiceSelection((prev) => ({
                                    ...prev,
                                    monthName: nextMonth,
                                  }));
                                  fieldRenderProps.onChange(ev);
                                }}
                              />
                            );
                          }}
                        />
                      </div>
                      <div className="mt-4 flex justify-end">
                        <Button
                          type="button"
                          className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                          onClick={handleGenerateInvoice}
                        >
                          <FormattedMessage id="organization.generateInvoiceButton" />
                        </Button>
                      </div>
                        </>
                      )}
                    </div>
                    )}

                    <div className="flex mt-4 gap-4 justify-start">
                      <Button
                        type="submit"
                        className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                     hover:text-black focus:outline-none px-4 py-2"
                      >
                        {props.formType === "NEW"
                          ? intl.formatMessage({ id: "saveButton" })
                          : intl.formatMessage({ id: "updateButton" })}
                      </Button>

                      <Button
                        key={formKey}
                        onClick={handleCancelClick}
                        className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey
                                                hover:text-black focus:outline-none px-4 py-2"
                      >
                        <FormattedMessage id="cancelButton" />
                      </Button>
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />
        )}
      </div>
      <div className="pb-[15%]"></div>
    </div>
  );
}
